import { IGetAllAssistenciaTecnicaUseCase } from "../../../presentation/useCases/read/get_all_assistencia_tecnica_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { AssistenciaTecnicaLista } from "../../models/assistencia_tecnica_lista";

/**
 * GetAllAssistenciaTecnicaUseCase
 */

export class GetAllAssistenciaTecnicaUseCase
  extends BasePaginatedUseCase<AssistenciaTecnicaLista>
  implements IGetAllAssistenciaTecnicaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async getAllAssistenciaTecnica(
    idCliente: number[] | null,
    cliente: string | null,
    centroCustos: number[] | null,
    local: string | null,
    dataAberturaDe: Date | null,
    dataAberturaAte: Date | null,
    tipo: number | null,
    dataEncerramentoDe: Date | null,
    dataEncerramentoAte: Date | null,
    codigo: number | null,
    procedente: number | null,
    categorias: number[] | null,
    resolvido: number | null,
    prioridade: number | null,
    nroChamado: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const result = await this.repository.getAllAssistenciaTecnica(
      idCliente,
      cliente,
      centroCustos,
      local,
      dataAberturaDe,
      dataAberturaAte,
      tipo,
      dataEncerramentoDe,
      dataEncerramentoAte,
      codigo,
      procedente,
      categorias,
      resolvido,
      prioridade,
      nroChamado,
      status,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
